import { useDispatch, useSelector } from 'react-redux';
import { getTextProcessStatus, inspection, getInspectionSettings } from 'store';
import GVCheckbox from 'components/lib/GVCheckbox/GVCheckbox';
import BarcodeMenu from './BarcodeMenu';

const BarcodeSettings = () => {
  const dispatch = useDispatch();
  const documentProcessed = useSelector(getTextProcessStatus);
  const inspectionSettings = useSelector(getInspectionSettings);

  const toggleBarcodeCheck = () => {
    dispatch(inspection.actions.setInspectionSettings({ barcode: !!!inspectionSettings.barcode }));
  };

  return (
    <>
      <GVCheckbox
        checked={!!inspectionSettings.barcode}
        onChange={toggleBarcodeCheck}
        label="Barcode & QR Code"
        data-testid="barcodeinspection_enable"
        disabled={!documentProcessed}
      />
      {documentProcessed && inspectionSettings.barcode && <BarcodeMenu />}
    </>
  );
};

export default BarcodeSettings;
